import { useState } from "react";

/**
 * Persistent footer-style banner showing the data classification level.
 * Required by P5 — all users see this regardless of storage tier.
 */
export default function DataClassificationBanner() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div style={bannerStyle} data-testid="data-classification-banner">
      <span style={{ fontSize: 13, marginRight: 6 }}>🔒</span>
      <span style={{ flex: 1, fontSize: 12 }}>
        <strong>Internal</strong> — Non-Sensitive
      </span>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        style={dismissStyle}
        aria-label="Dismiss classification banner"
        data-testid="data-classification-dismiss"
      >
        ✕
      </button>
    </div>
  );
}

const bannerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  padding: "4px 16px",
  borderTop: "1px solid #d0d7de",
  background: "var(--color-surface-low)",
  flexShrink: 0,
  fontFamily: "system-ui, sans-serif",
  color: "var(--color-text-secondary)",
};

const dismissStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  fontSize: 12,
  cursor: "pointer",
  color: "var(--color-gray-60)",
  padding: "0 4px",
  marginLeft: 8,
};
